import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface ArticleSelectProps {
    setSelectedStatut: (statut: string) => void;
    selectedStatut: string | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const StatutCarteSelect: React.FC<ArticleSelectProps> = ({ setSelectedStatut, selectedStatut }) => {
    const statuts: string[] = ['Actif', 'Inactif'];

    const options: ISelectOption[] = statuts.map((statut) => ({
        value: statut,
        label: statut,
    }));

    const selectedOption = options.find((option) => option.value === selectedStatut) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedStatut(selectedOption ? selectedOption.value : 'Actif');
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={'--- Statut'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default StatutCarteSelect;
